export class ReportViewer {
  public ReportBase64: string;
}
